var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background":"linear-gradient(180deg, #05366900 0%, rgb(223, 70, 70) 350px, rgb(223, 70, 70) 550px, #290036 1050px)"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }